export const DEF_ROL_NAME = "Usuario";

export const DEF_ROL = {
	name: DEF_ROL_NAME,
	id: 0,
}
